import { productWizardConsole } from '@athena-lib/ProductWizard/util/productWizardLog';
import type { ProductItem } from '../model/ProductItem';
import type { ProductAttrComputer } from '../helper/ProductAttrComputer';
import type { ProductProcessorInterface } from './ProductProcessorInterface';
import type { ProductProcessCallbackInterface } from './ProductProcessCallbackInterface';
import type { ProductProcessorsEnum } from './ProductProcessorsEnum';

export class ProductProcessorsCollection {
  // TODO: Be able to prioritize processors

  protected processors: Map<string, ProductProcessCallbackInterface> = new Map<
    string,
    ProductProcessCallbackInterface
  >();

  public invokeProcessors(productItem: ProductItem, attrComputer: ProductAttrComputer): void {
    this.processors.forEach((processor, id) => {
      productWizardConsole.log('Invoking processor: ', id);
      processor(productItem, attrComputer);
    });
  }

  public registerProcessor(
    id: ProductProcessorsEnum,
    processor: ProductProcessorInterface | ProductProcessCallbackInterface,
  ): void {
    if (this.processors.has(id.valueOf())) {
      throw Error(`Processor with id ${id} already exists.`);
    }

    if ('invoke' in processor) {
      this.processors.set(id.valueOf(), (productItem, attrComputer) =>
        processor.invoke(productItem, attrComputer),
      );
    } else {
      this.processors.set(id.valueOf(), processor);
    }
  }

  public unregisterProcessor(id: ProductProcessorsEnum): boolean {
    if (this.processors.has(id.valueOf())) {
      return this.processors.delete(id.valueOf());
    }

    return false;
  }
}
